// Auto-generated by robust sync script
export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "O link para o seu anúncio do Airbnb é obrigatório",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "A classificação do Airbnb deve ser de pelo menos 4 a 5",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Crie uma conta verifique seu e-mail para ativar seu acesso ao clube",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Clube reservado para hóspedes do Airbnb não s'4 5",
  comparez_vos_gains_r_els: "Compare seus ganhos reais",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "O mod traveltrok é um vencedor, o viajante ganha",
  votre_prix_sur_les_autres_sites: "Seu preço em outros sites",
  diminuer_le_prix: "Reduza o preço",
  augmenter_le_prix: "Aumentar o preço",
  net_pour_vous: "Rede para você",
  de_commissions: "Comissões",
  prix_pay__par_le_voyageur: "Preço pago pelo viajante",
  revenu___d_clarer__imp_ts_: "Renda para declarar impostos",
  vous_d_clarez_100__du_prix____commissions__:
    "Você declara 100 das comissões de preço",
  de_frais_h_te: "Taxas de anfitrião",
  __0__compar____booking_: "0 reserva de comparação",
  mod_le_frais_h_te__depuis_25_____: "Modifique a taxa de anfitrião desde 25",
  vous_d_clarez_100__du_prix_voyageur_:
    "Você declara 100 do preço do passageiro",
  strat_gie_gagnante: "Estratégia vencedora",
  prix_voyageur: "Preço do viajante",
  _5__pour_le_voyageur: "5 para o viajante",
  le_meilleur_des_deux_mondes: "O melhor dos dois mundos",
  avantage_fiscal: "Vantagem fiscal",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "Você declara menos e paga menos impostos",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Sc nario traveltrok aplica 5 taxas de viajante",
  appartement: "Apartamento",
  maison: "Lar",
  inclut_villa_chalet: "Inclui villa chalé",
  loft: "Sótão",
  luxe: "Luxo",
  insolite: "Incomum",
  autre: "Outro",
  campagne: "Campanha",
  mer: "Mar",
  montagne: "Montanha",
  au_dessus_de_500_nuit: "Acima de 500€/noite",
  aucun_resultat_dynamique: "Sem resultados dinâmicos",
  service_de_localisation_indisponible__r_essayez_da:
    "Serviço de localização indisponível. Tente novamente em alguns instantes",
  quel_type_de_logement_souhaitez_vou:
    "Que tipo de alojamento pretende oferecer?",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Escolha a categoria que melhor descreve o seu alojamento",
  quel_est_le_cadre_du_logement__: "Como é o ambiente habitacional?",
  o__est_situ__votre_logement__: "Onde está localizado o seu alojamento?",
  pays_europ_en_de_r_f_rence: "País europeu de referência",
  ville__village__code_postal___: "Cidade, vila, código postal...",
  recherche_en_cours___: "Pesquisa em andamento...",
  recherche___: "Pesquisar...",
  localiser: "Localizar",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "Usaremos este endereço para localizar sua acomodação",
  localis_: "Localizado",
  _copy__openstreetmap_france: "© OpenStreetMap França",
  emplacement_valid_: "Localização validada",
  d_crivez_votre_logement: "Descreva sua acomodação",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Faça os viajantes quererem ficar com você",
  titre_de_l__annonce: "Título do anúncio",
  ex__charmant_studio_au_c_ur_de_paris:
    "Ex: Estúdio charmoso no coração de Paris",
  soyez_concis_et_accrocheur: "Seja conciso e cativante",
  description_d_taill_e: "Descrição detalhada",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Fale sobre sua acomodação, o bairro, as comodidades...",
  mentionnez_les_points_forts: "Mencione os pontos fortes",
  voyageurs: "Viajantes",
  chambres: "Quartos",
  lits: "Camas",
  salles_de_bain: "Banheiros",
  d_tails_du_logement: "Detalhes da acomodação",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Dê mais informações sobre a capacidade de recepção",
  surface__m__: "Área (m²)",
  ex__85: "Exemplo: 85",
  ajoutez_des_photos: "Adicionar fotos",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Destaque sua casa com lindas imagens",
  glissez_vos_photos_ici: "Arraste suas fotos aqui",
  parcourez_vos_fichiers: "Navegue pelos seus arquivos",
  jpg__png_jusqu____5_mo: "JPG, PNG (até 5 MB)",
  d_j__en_ligne: "Já on-line",
  __uploader: "Para fazer upload",
  fixez_votre_prix: "Defina seu preço",
  vous_pourrez_le_modifier___tout_moment_:
    "Você pode modificá-lo a qualquer momento",
  par_nuit: "Por noite",
  aper_u_de_votre_annonce: "Visualize seu anúncio",
  titre_de_votre_annonce: "Título do seu anúncio",
  nouveau: "Novo",
  localisation: "Localização",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Excluindo o tipo de perfil, exclua e confirme se a exclusão completa for impossível, seu perfil será pausado e oculto",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Concluir exclusão de perfil indisponível pausado e ocultado",
  preferences: "Preferências",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Gerencie suas unidades, sua visibilidade e o status do seu perfil",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "Você permanece conectado, mas seus anúncios não estão mais ativos nas sugestões",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Seu perfil e suas acomodações não aparecem mais no mapa e nas páginas de destino",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "Banco de dados não migrado, suas preferências estão salvas localmente por enquanto",
  delai_depasse: "Prazo ultrapassado",
  echeance_aujourd__hui: "Vencimento hoje",
  mois_restants: "Meses restantes",
  nuits_dues_et_aucun_accueil_effectue:
    "Noites vencidas e sem recepção realizada",
  suivi_des_echanges: "Monitoramento de exchanges",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Acompanhe as noites devidas em ambos os sentidos, quem lhe deve, quem lhe deve e o tempo restante para fechar cada troca",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Nomeie as datas do contrato de acomodação, status de ambas as partes e tempo restante",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Visualize suas cidades-alvo e raios de pesquisa em torno de cada ponto",
  __d_couvrir___: "cobrir",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "Os locais essenciais a visitar durante a sua estadia",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "Não foi possível finalizar a solicitação, tente novamente em",
  r_server_ton_s_jour___: "reserve a sua estadia",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Pesquisa simples de detalhes em 3 etapas v",
  recherche: "Pesquisar",
  validation: "Validação",
  demande_envoy_e: "Solicitação enviada",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "Um anfitrião responderá rapidamente com detalhes",
  cr_er_une_nouvelle_demande: "criar uma nova solicitação",
  "1__ton_s_jour": "1 dia",
  arriv_e: "Chegada",
  pers_: "Pessoas",
  dates_flexibles: "Datas flexíveis",
  dates_exactes: "Datas exatas",
  _3_jours: "3 dias",
  _7_jours: "7 dias",
  _14_jours: "14 dias",
  je_voyage_avec_des_animaux: "Eu viajo com animais",
  "2__infos_r_servation": "2 informações de reserva",
  nom_complet: "Nome completo",
  ex__clara_martin: "ex clara martin",
  message___l_h_te: "Envie uma mensagem ao anfitrião",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "O tempo de chegada rápido da apresentação precisa de parte",
  "3__validation_de_la_r_servation": "3 validação da reserva",
  destination: "Destino",
  s_jour: "ficar",
  flexibilit_: "Flexibilidade",
  tarification_traveltrok: "preços traveltrok",
  frais_plateforme: "Taxas de plataforma",
  "1eur_voyageur___1eur_h_te": "1seu viajante 1seu anfitrião",
  incluse: "Incluído",
  total_estim_: "Estimativa total",
  continuer: "Continuar",
  envoi___: "Enviando",
  confirmer_ma_r_servation: "Confirmar minha reserva",
  r_sum__intelligent: "R soma inteligente",
  prix_base: "Preço base",
  total_actuel: "Total atual",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "Inclui 1 hóspede e 1 hóspede por noite assuran",
  membres_actifs: "Membros ativos",
  note_moyenne: "Avaliação média",
  d_couvrez_: "descobrir",
  points_forts: "Destaques",
  conseils_pratiques: "Conselhos práticos",
  informations_pratiques: "Informações práticas",
  meilleure_saison: "Melhor temporada",
  s_jour_moyen: "estadia média",
  langue: "Linguagem",
  monnaie: "Dinheiro",
  fuseau_horaire: "Fuso horário",
  voir_les_logements: "Veja as acomodações",
  nous_contacter: "Contate-nos",
  villa: "Vila",
  logements_disponibles___: "Acomodações disponíveis",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Listagens noturnas com anfitriões verificados",
  voir_la_carte_des_logements: "Veja o mapa de alojamento",
  h_te_v_rifi_: "anfitrião verificado",
  mod_le_traveltrok: "Modifique o traveltrok",
  r_server: "reservar",
  pas_encore_de_logements_ici: "Nenhuma acomodação aqui ainda",
  sois_le_premier_h_te___proposer_son_logement___:
    "Seja o primeiro anfitrião a oferecer sua acomodação",
  ajouter_mon_logement: "Adicionar minha acomodação",
  destinations_proches: "Destinos próximos",
  explorez_d_autres_destinations_en_: "Explore outros destinos em",
  am_rique_du_nord: "América do Norte",
  am_rique_du_sud: "Ámérica do Sul",
  oc_anie: "Oceânia",
  afrique: "África",
  asie: "Ásia",
  europe: "Europa",
  carte_des_destinations: "Mapa de destino",
  destinations_affich_es: "Destinos exibidos",
  continents: "Continentes",
  survolez_un_point_pour_voir_les_d_tails:
    "Passe o mouse sobre um ponto para ver detalhes",
  _changes_r_alis_s: "alterações feitas",
  mes_favoris: "Meus favoritos",
  sauvegard_: "Backup",
  tout_effacer: "Limpar tudo",
  s_lectionn_: "Seleção",
  pour_comparaison: "Para comparação",
  voir_la_comparaison: "Veja a comparação",
  trier_par__: "ordenar por",
  note: "Observação",
  _changes: "mudanças",
  capacit_: "Capacidade",
  pi_ces: "Peças",
  type_de_logement: "Tipo de acomodação",
  effacer: "Para apagar",
  r_initialiser_les_filtres: "Filtros de inicialização R",
  filtres_actifs__: "Filtros ativos",
  aucun_r_sultat: "Nenhum resultado",
  aucun_favori_ne_correspond___vos_filtres_:
    "Nenhum favorito corresponde aos seus filtros",
  comparaison_des_logements: "Comparação de acomodação",
  logements_s_lectionn_s: "Acomodações selecionadas",
  fermer: "Fechar",
  astuce: "Truque",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Use os filtros para refinar seus favoritos",
  type: "Tipo",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "Em seguida, selecione até 4 slots para o",
  aucun_sch_ma_conversation_compatible_trouv__:
    "Nenhuma conversa compatível foi encontrada",
  souhaite_venir_dynamique: "Desejo ser dinâmico",
  aimerais_visiter_dynamique: "Gostaria de visitar dinâmico",
  demande_ignor_e_: "Solicitação ignorada",
  conversation_introuvable_: "Conversa não encontrada",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "Não é possível abrir a discussão no momento",
  demande_supprim_e_: "Solicitação excluída",
  bonjour_merci_dynamique: "Olá obrigado dinâmico",
  demande_supprim_e_avec_un_message_poli_:
    "Solicitação excluída com uma mensagem educada",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "Não é possível excluir esta solicitação neste momento",
  demandes_directes: "Solicitações diretas",
  matching_auto: "Eles querem vir para sua área",
  match_r_ciproque: "Correspondência recíproca",
  carte_secteur: "Cartão do setor",
  toutes: "Todos",
  lik_es: "Apreciado",
  en_discussion: "Em discussão",
  ignor_es: "Ignorado",
  sans_date_pr_cise__juste__change_: "Sem data específica basta trocar",
  date_pr_cise___dans_les_6_mois: "Data específica dentro de 6 meses",
  date_pr_cise___dans_l_ann_e: "Data específica no ano",
  flexible: "Flexível",
  date_pr_cise: "Data específica",
  dates_identiques: "Mesmas datas",
  dates_compatibles: "Datas compatíveis",
  dates_diff_rentes: "Datas diferentes",
  dates_inconnues: "Datas desconhecidas",
  souhaite_venir__: "Desejo vir",
  voir_le_logement_cibl_: "Ver alojamento alvo",
  personnes_int_ress_es_par_votre_secteur: "Pessoas interessadas no seu setor",
  vert___match_r_ciproque_ville___dates:
    "Datas da cidade de correspondência recíproca verde",
  int_r_t_entrant: "Juros recebidos",
  logement_cibl___: "Habitação direcionada",
  dates__: "Datas",
  sans_date_pr_cise: "Sem data específica",
  ouvrir_le_chat: "Abrir bate-papo",
  pas_encore_de_points_sur_la_carte: "Ainda não há pontos no mapa",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Membros que desejam vir à sua área para",
  logement_vis_: "Alojamento direcionado",
  demande: "Solicitar",
  message: "Mensagem",
  logement_s_: "alojamento(s)",
  annonce_indisponible: "Anúncio indisponível",
  jour_s_: "dias)",
  dur_e___d_finir: "Duração para terminar",
  match_auto: "Correspondência automática",
  r_ciproque: "Recíproca",
  discuter_dans_la_messagerie: "Bate-papo em mensagens",
  ignorer_la_demande: "Ignorar o pedido",
  ignorer: "Ignorar",
  supprimer_avec_message_poli: "Excluir com mensagem educada",
  poli: "Educado",
  supprimer_sans_message: "Excluir sem mensagem",
  suppr_: "Excluir",
  aucune_demande_pour_le_moment: "Nenhum pedido no momento",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "O quadro está pronto e os pedidos aparecerão aqui",
  surface: "Superfície",
  voyagez: "Viagem",
  envie_d___changer_avec_: "Quer mudar com",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Propor uma troca de habitação e cobrir",
  gratuitement_: "Livre",
  voir_la_fiche_du_logement: "Veja a ficha de alojamento",
  carte_des_logements: "Mapa habitacional",
  r_sultats_visibles: "resultados visíveis",
  jour: "Dia",
  s_lectionn_s: "selecionado",
  printemps: "Primavera",
  _t_: "t",
  automne: "Outono",
  hiver: "Inverno",
  toute_l__ann_e: "Durante todo o ano",
  bonjour_host_dynamic: "Olá anfitrião dinâmico",
  impossible_de_contacter_cet_h_te____errormessage__:
    "Não foi possível entrar em contato com esta mensagem de erro de host",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "Não é possível entrar em contato com este anfitrião no momento",
  annonce_introuvable_: "Anúncio não encontrado",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Escolha as datas para enviar a proposta",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "A data de partida deve ser posterior à data de chegada",
  proposition_d__change_avec_dates_pr_cises:
    "Proposta de troca com datas específicas",
  __logement_cibl_: "Habitação direcionada",
  __ville: "Cidade",
  __arriv_e_souhait_e: "Chegada desejada",
  __d_part_souhait_: "Partida desejada",
  __dur_e: "Duração",
  nuit_s_: "Noite(s)",
  __voyageurs: "Viajantes",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "Estou aberto a negociações se necessário.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Indique um número válido de noites para a proposta",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Proposta de troca flexível sem datas fixas",
  __je_propose: "eu proponho",
  __je_demande: "eu pergunto",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "Validamos então as datas em conjunto de acordo com a nossa disponibilidade.",
  indiquez_un_nombre_de_nuits_valide_: "Insira um número válido de noites",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Proposta de troca em qualquer época do ano",
  __dur_e_souhait_e: "Duração desejada",
  __p_riode_pr_f_r_e: "Período preferencial",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "Sou flexível em datas exatas e estou disposto a conversar sobre isso.",
  proposition_invalide_: "Proposta inválida",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Proposta enviada, discussão aberta...",
  impossible_d_envoyer_votre_proposition____errormes:
    "Não foi possível enviar sua proposta",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "Não é possível enviar sua proposta no momento",
  logement_introuvable: "Alojamento não encontrado",
  retour_aux_logements: "Retorno ao alojamento",
  annonce_airbnb: "Anúncio Airbnb",
  lien_airbnb_verification_helper:
    "Este link nos permite verificar se você é o gerente do anúncio.",
  aucune_photo_disponible: "Nenhuma foto disponível",
  logement_propos__par: "Alojamento oferecido por",
  __propos_de_ce_logement: "Sobre este alojamento",
  aucune_description_fournie_: "Nenhuma descrição fornecida",
  ce_que_propose_ce_logement: "O que este alojamento oferece",
  description_du_logement: "Descrição do alojamento",
  aucun__quipement_sp_cifi__: "Nenhum equipamento especificado",
  _change_entre_h_tes: "troca entre hosts",
  votre_proposition_d__change: "Sua proposta de troca",
  quand_vous_voulez: "Quando você quiser",
  je_propose: "eu proponho",
  nuits_chez_moi: "Noites na minha casa",
  je_demande: "eu pergunto",
  nuits_chez_vous: "Noites em sua casa",
  nombre_de_nuits: "Número de noites",
  p_riode_pr_f_r_e: "Período preferencial",
  message__optionnel_: "Mensagem opcional",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Ex somos flexíveis podemos nos adaptar ao seu",
  entrer_en_n_gociation: "Entre em negociação",
  envoyer_ma_proposition: "Enviar minha proposta",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "Você pode oferecer uma troca com ou sem datas",
  informations_l_gales: "Informações legais",
  conditions_d____utilisation: "Termos de uso",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "Ao usar o traveltrok você concorda em usar",
  les__changes_se_font_directement_entre_membres__:
    "As trocas são feitas diretamente entre os membros",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "A DONKEY TRAVEL pode suspender uma conta em caso de co",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "Ao aderir à DONKEY TRAVEL, você aceita estes compromissos. A confiança se baseia em ações simples.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "Uma carta sólida alinhada com as melhores práticas de outras empresas famosas.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Saída do clube por reincidência ou falta grave.",
  exclusion_d_finitive: "Exclusão permanente",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Conta restrita aguardando fatos.",
  suspension_temporaire: "Suspensão temporária",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Lembrete das regras e correções necessárias.",
  avertissement_officiel: "Aviso oficial",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "O clube protege hóspedes confiáveis. Violações graves resultam em ação.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Qualquer cancelamento deve ser documentado em mensagens e processado pelo suporte.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "Não cancelamos uma troca sem motivo válido. Em caso de força maior (catástrofe, doença grave, impossibilidade legal), deverá ser proposto um adiamento o mais rapidamente possível.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "Comunico-me rapidamente em caso de dúvida ou alteração.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "Dou as boas-vindas a alguém que faz o mesmo trabalho que um anfitrião.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "Ofereço uma recepção calorosa e profissional.",
  relation_entre_h_tes: "Relacionamento entre hosts",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Quaisquer taxas de limpeza são anunciadas e validadas antes da troca.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "As informações de acesso e operação são claras.",
  linge_et_pr_paration: "Lavanderia e preparação",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "O nível de serviço permanece o mesmo, mesmo numa troca gratuita.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "A acomodação está limpa e pronta para morar na chegada.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "Preparo o alojamento como para um cliente Airbnb.",
  qualit__d_accueil__quivalente: "Qualidade de recepção equivalente",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "Respeito a calma, os vizinhos e a vizinhança.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "Não são permitidas festas, eventos ou convites não autorizados no alojamento.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "Respeito os regulamentos internos do anfitrião.",
  vie_de_quartier_et_r_gles: "Vida e regras do bairro",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "Quando as datas estão bloqueadas, comprometo-me a vir.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "Não minto sobre o valor habitual do preço do meu alojamento.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "Não minto no meu perfil, na minha história ou na minha acomodação.",
  honn_tet__et_fiabilit_: "Honestidade e confiabilidade",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "Respeito os materiais, equipamentos e instruções de saída.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "Guardo roupa de cama usada (ex. lençóis em formato de bola) no local indicado, para limitar os custos de limpeza.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "Deixo a acomodação tão limpa quanto a encontrei.",
  respect_total_du_logement: "Respeito total pela habitação",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "DONKEY TRAVEL é um clube anfitrião sério; uma boa classificação implica uma conduta exemplar, tanto como viajante como como anfitrião.",
  "howItWorks.cta.explore": "Explorar destinos",
  "howItWorks.cta.signup": "Veja nossas ofertas",
  "howItWorks.cta.subtitle":
    "Comece alugando seu próprio lugar. Em seguida, ative o intercâmbio se quiser trocar entre hosts.",
  "howItWorks.cta.title": "Pronto para lançar seus aluguéis?",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Publique o seu alojamento, valide o seu perfil e comece a receber ofertas de troca.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "Veja a densidade de moradias já cadastradas no clube. Os pontos permanecem anônimos (sem endereço, sem detalhes, apenas dinâmica da rede).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Dê um passo para trás para evitar o esgotamento da hospedagem contínua.",
  _an: "/ ano",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "DONKEY TRAVEL conecta hóspedes de todo o mundo para estadias autênticas e acessíveis.",
  ____100__made_in_france__picardie_: "🇫🇷 100% Fabricado na França (Picardia)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "Não o Vale do Silício, mas o vale do Haute-Somme.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Intercâmbios em toda a Europa entre anfitriões do Airbnb com classificação 4,5+. Oferta de lançamento em 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "Após meses de hospedagem, transforme seus períodos de lentidão em um verdadeiro espaço para respirar sem estourar seu orçamento.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Dê um passo para trás para evitar o esgotamento da hospedagem contínua.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Dê as boas-vindas aos convidados que já conhecem os requisitos da área e, em seguida, compartilhe seus métodos e comentários.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Viaje com custos reduzidos graças ao intercâmbio entre membros do clube.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "Quando sua cota local for atingida, você poderá negociar fora da plataforma, sujeito à conformidade local.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "DONKEY TRAVEL é uma revolução europeia: uma plataforma de troca para hóspedes que já pagam aquecimento, impostos, electricidade, internet e manutenção, e recebem durante todo o ano como num hotel. Aqui você interage com anfitriões que sabem te receber, você compartilha suas experiências, depois vai descobrir outro lugar sem gastar muito.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉 Nosso modelo é baseado exclusivamente em assinaturas, não na exploração de dados.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Sem anúncios. Sem revenda de dados. 100% financiado pelos membros.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "O clube não é um conselho jurídico; cada membro deve respeitar as regras locais (declarações, quotas, co-propriedade, tributação, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "Uma plataforma de intercâmbio europeia reservada para anfitriões Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Clube privado para hóspedes com classificação 4,5+: uma assinatura exclusiva para intercâmbio em toda a Europa.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Reservado para anfitriões do Airbnb com classificação maior ou igual a 4,5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Redução de 50% em 2026: 25EUR/ano em vez de 50EUR/ano. Preço garantido vitaliciamente para as primeiras 1000 inscrições.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Época baixa, pausas, reuniões entre hóspedes, poupanças nas férias: tudo pensado para hóspedes activos na Europa.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Dê as boas-vindas aos membros e seja bem-vindo de volta. Uma troca simples, direta e sem dinheiro entre proprietários.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    "'\"Trocamos a nossa casa em Lyon por uma villa na Córsega. Custo: 0 €.\"'",
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "Sem moedas, sem pontos. Apenas um acordo entre dois proprietários. Eu vou na sua casa, você vem na minha casa.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "Você encontra um membro de quem gosta e concorda em trocar de acomodação.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "Não há pontos para contar. Apenas o prazer de compartilhar e conhecer.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "Mais do que uma economia, é uma nova forma de viajar.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "As trocas são totalmente gratuitas. Sem taxas de serviço, sem taxas de limpeza (a menos que especificamente acordado).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Somente hosts verificados podem negociar. Você está recebendo alguém que conhece o valor de uma casa.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Esqueça o valor dos pontos. Uma noite é uma noite. A troca é baseada na confiança entre hosts.",
  __an: "/ ano",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Intercâmbios em toda a Europa entre anfitriões do Airbnb com classificação 4,5+. Oferta de lançamento em 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "Após meses de hospedagem, transforme seus períodos de lentidão em um verdadeiro espaço para respirar sem estourar seu orçamento.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Dê um passo para trás para evitar o esgotamento da hospedagem contínua.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Dê as boas-vindas aos convidados que já conhecem os requisitos da área e, em seguida, compartilhe seus métodos e comentários.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Viaje com custos reduzidos graças ao intercâmbio entre membros do clube.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "Quando sua cota local for atingida, você poderá negociar fora da plataforma, sujeito à conformidade local.",
  la_r_volution_des_h_tes_en_europe: "A revolução dos anfitriões na Europa",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Finalmente uma pausa para anfitriões do Airbnb com classificação 4,5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "DONKEY TRAVEL é uma revolução europeia: uma plataforma de troca para hóspedes que já pagam aquecimento, impostos, electricidade, internet e manutenção, e recebem durante todo o ano como num hotel. Aqui você interage com anfitriões que sabem te receber, você compartilha suas experiências, depois vai descobrir outro lugar sem gastar muito.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Preço garantido vitaliciamente para as primeiras 1000 inscrições.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "Na DONKEY TRAVEL, seus dados não são um produto.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "Nunca vendemos informações de nossos membros.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "Não compartilhamos quaisquer dados com terceiros para fins comerciais.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "O site é seguro e suas trocas permanecem privadas.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "DONKEY TRAVEL é garantido sem publicidade: você é o membro, não o produto.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉 Nosso modelo é baseado exclusivamente em assinaturas, não na exploração de dados.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Sem anúncios. Sem revenda de dados. 100% financiado pelos membros.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "O clube não é um conselho jurídico; cada membro deve respeitar as regras locais (declarações, quotas, co-propriedade, tributação, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "Uma plataforma de intercâmbio europeia reservada para anfitriões Airbnb",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Clube privado para hóspedes com classificação 4,5+: uma assinatura exclusiva para intercâmbio em toda a Europa.",
  acc_s_r_serv_: "Acesso reservado",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Reservado para anfitriões do Airbnb com classificação maior ou igual a 4,5.",
  europe_unique: "Europa única",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50EUR/ano para intercâmbio em toda a Europa.",
  lancement_2026: "Lançamento 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "Redução de 50% em 2026: 25EUR/ano em vez de 50EUR/ano. Preço garantido vitaliciamente para as primeiras 1000 inscrições.",
  club_d__change_h_tes_airbnb: "Clube de intercâmbio de anfitriões do Airbnb",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Otimize seus períodos fora de pico graças às trocas",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Época baixa, pausas, reuniões entre hóspedes, poupanças nas férias: tudo pensado para hóspedes activos na Europa.",
  r_serv__aux_h_tes_traveltrok: "Reservado para hóspedes da DONKEY TRAVEL",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Viaje de graça com sua acomodação",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Dê as boas-vindas aos membros e seja bem-vindo de volta. Uma troca simples, direta e sem dinheiro entre proprietários.",
  devenir_h_te: "Torne-se um anfitrião",
  comment__a_marche__: "Como funciona?",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    "'\"Trocamos a nossa casa em Lyon por uma villa na Córsega. Custo: 0 €.\"'",
  amis_partageant_un_repas_en_corse:
    "Amigos compartilhando uma refeição na Córsega",
  sophie___marc__membres_depuis_2023: "Sophie e Marc, membros desde 2023",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "Não precisa trocar nas mesmas datas: você vem na minha casa em junho, eu vou na sua casa em setembro!",
  l__change_direct___simple_et_humain: "Troca direta: simples e humana",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "Sem moedas, sem pontos. Apenas um acordo entre dois proprietários. Eu vou na sua casa, você vem na minha casa.",
  "1__accord_mutuel": "1. Acordo mútuo",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "Você encontra um membro de quem gosta e concorda em trocar de acomodação.",
  "2__flexibilit__totale": "2. Flexibilidade total",
  "3__z_ro_comptabilit_": "3. Contabilidade zero",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "Não há pontos para contar. Apenas o prazer de compartilhar e conhecer.",
  pourquoi_les_h_tes_adorent_ce_syst_me__:
    "Por que os hosts adoram esse sistema?",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "Mais do que uma economia, é uma nova forma de viajar.",
  "0__de_frais": "0€ taxas",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "As trocas são totalmente gratuitas. Sem taxas de serviço, sem taxas de limpeza (a menos que especificamente acordado).",
  confiance_totale: "Confiança total",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Somente hosts verificados podem negociar. Você está recebendo alguém que conhece o valor de uma casa.",
  simplicit_: "Simplicidade",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Esqueça o valor dos pontos. Uma noite é uma noite. A troca é baseada na confiança entre hosts.",
  rejoignez_la_communaut__des_h_tes: "Junte-se à comunidade de anfitriões",
  rejoignez_la_communaut__et_commencez____changer_:
    "Junte-se à comunidade e comece a conversar.",
  commencer_maintenant: "Comece agora",
  chargement___: "Carregando...",
  accueil: "Bem-vindo",
  comment_a_marche: "Como funciona",
  vos_engagements: "Seus compromissos",
  pays: "País",
  logements: "Habitação",
  _change_h_te: "Troca de hosts",
  devenir_membre: "Torne-se um membro",
  se_d_connecter: "Sair",
  mon_espace: "Meu espaço",
  connexion: "Conexão",
  connect_: "Conectado",
  visuel_en_cours_de_g_n_ration_ai___: "Visual sendo gerado AI...",
  tableau_de_bord: "Painel",
  mes_annonces: "Meus anúncios",
  o__je_veux_aller: "Para onde eu quero ir",
  qui_veut_venir_chez_moi: "Correspondência inteligente",
  destinations: "Destinos",
  carte_des_membres: "Cartão de membro",
  calendrier: "Calendário",
  votre_coffre: "Seu cofre",
  favoris: "Favoritos",
  messages: "Mensagens",
  mon_profil: "Meu perfil",
  pr_f_rences: "Preferências",
  profil: "Perfil",
  h_te: "Hospedar",
  membre_fondateur: "Membro Fundador",
  membre: "Membro",
  r_duire__tendre: "Reduzir/expandir",
  r_duire_le_menu: "Recolher menu",
  cette_page_n_a_pas__t__g_n_r_e: "Esta página não foi gerada",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Dê-me mais detalhes sobre esta página para que eu possa gerá-la",
  connexion_en_cours___: "Conexão em andamento...",
  email_ou_mot_de_passe_incorrect: "E-mail ou senha incorretos",
  une_erreur_est_survenue: "Ocorreu um erro",
  erreur_de_connexion_google: "Erro de conexão do Google",
  connecte_toi_pour_retrouver_ta_communaut_:
    "Faça login para encontrar sua comunidade",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Junte-se à comunidade de anfitriões DONKEY TRAVEL",
  inscription: "Cadastro",
  continuer_avec_google: "Continuar com o Google",
  ou: "Ou",
  ton_pr_nom_et_nom: "Seu nome e sobrenome",
  jean_h_mar: "Jean Hemar",
  lien_annonce_airbnb: "Link para o seu anúncio do Airbnb",
  veuillez_saisir_un_lien_airbnb_valide: "Forneça um link válido do Airbnb",
  lien_calendrier_ical:
    "Link iCal para o seu calendário do Airbnb (opcional por enquanto)",
  lien_ical_explication_lecture_seule:
    "A Donkey Travel nunca altera o seu calendário do Airbnb. Acabamos de ler para mostrar sua disponibilidade. Você precisará continuar bloqueando manualmente as datas de resgate no Airbnb para evitar reservas duplicadas.",
  note_airbnb: "Avaliação do Airbnb",
  abonnement: "Subscrição",
  europe_unique___50eur_an: "Europa Única - 50EUR/ano",
  offre_lancement_2026__25eur_an___50__:
    "Oferta de lançamento 2026: 25EUR/ano (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Preço garantido vitaliciamente para as primeiras 1000 inscrições.",
  mot_de_passe: "Senha",
  "8_caract_res_minimum": "Mínimo de 8 caracteres",
  connexion___: "Conexão...",
  cr_ation_du_compte___: "Criando a conta...",
  se_connecter: "Conecte-se",
  cr_er_mon_compte: "Criar minha conta",
  mot_de_passe_oubli___: "Esqueceu a senha?",
  en_cr_ant_un_compte__tu_acceptes_nos_:
    "Ao criar uma conta, você concorda com nossos",
  cgu: "CGU",
  _et_notre_: "e nosso",
  politique_de_confidentialit_: "política de Privacidade",
  r_servation_de_logements: "Reserva de alojamento",
  support_h_te_prioritaire: "Suporte prioritário ao anfitrião",
  carte___filtres_avanc_s: "Mapa + filtros avançados",
  flux_de_r_servation__tape_par__tape: "Fluxo de reserva passo a passo",
  couverture_dommages_assistance: "Cobertura de danos/assistência",
  multi_logements___reporting: "Multi-habitação + relatórios",
  comparatif_des_modes: "Comparação de modos",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "O que você ativa de acordo com seu uso do TRAVELTROK.",
  fonction: "Função",
  voyageur: "Viajante",
  pro: "Pró",
  abonnement_europe_unique: "Assinatura única na Europa",
  rejoindre_le_club_europe: "Junte-se ao clube da Europa",
  basse_saison: "Baixa temporada",
  pause: "Faça uma pausa",
  rencontres: "Conheça os anfitriões",
  _conomies: "Poupança",
  quota_atteint: "Cota atingida",
  _ligibilit_: "Elegibilidade",
  zone_d__change: "Área de troca",
  toute_l_europe: "Toda a Europa",
  mod_le: "Modelo",
  abonnement_unique_annuel: "Assinatura anual única",
  propri_taire_europ_en_en_pause: "Proprietário europeu em pausa",
  v_rification: "Verificação",
  h_tes_certifi_s: "Anfitriões Certificados",
  abonnement_unique_traveltrok: "Assinatura única DONKEY TRAVEL",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Oferta de lançamento 2026: 25EUR/ano em vez de 50EUR/ano",
  pourquoi_ce_club_fonctionne_pour_les_h_tes:
    "Por que este clube funciona para anfitriões",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "Na DONKEY TRAVEL, seus dados não são um produto.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "Nunca vendemos informações de nossos membros.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "Não compartilhamos quaisquer dados com terceiros para fins comerciais.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "O site é seguro e suas trocas permanecem privadas.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "DONKEY TRAVEL é garantido sem publicidade: você é o membro, não o produto.",
  rejoindre_le_club: "Junte-se ao clube",
  trouver_un_h_te: "Encontre um anfitrião",
  proposer_un__change: "Sugira uma troca",
  synchronisation_mise___jour_avec_succ_s:
    "Sincronização atualizada com sucesso",
  erreur_lors_de_la_mise___jour: "Erro durante atualização",
  indisponible: "Indisponível",
  r_serv_: "Reserva",
  erreur_chargement: "Erro ao carregar",
  inconnue: "Desconhecido",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "Não foi possível recuperar o calendário iCal. Verifique o URL do iCal Airbnb e tente novamente.",
  r_servation: "Reserva",
  _v_nements_synchronis_s: "eventos sincronizados",
  _v_nements_import_s: "eventos importados",
  erreur_sync: "Erro de sincronização",
  _chec_de_synchronisation: "Falha de sincronização",
  dates_bloqu_es_avec_succ_s: "Datas bloqueadas com sucesso",
  erreur_blocage: "Erro de bloqueio",
  mois: "Mês",
  aujourd_hui: "Hoje",
  d_tails: "Detalhes",
  actions: "Ações",
  bloquer: "Para bloquear",
  filtres: "Filtros",
  confirm_: "Confirmado",
  en_attente: "Em espera",
  proposition: "Proposta",
  bloqu_: "Bloqueado",
  synchronisation: "Sincronização",
  configurer: "Configurar",
  airbnb_connect_: "Airbnb conectado",
  derni_re_synchro_r_ussie: "Última sincronização bem-sucedida",
  derni_re_synchro_en__chec: "Última falha na sincronização",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Calendário conectado. Inicie uma sincronização para importar suas reservas do Airbnb.",
  synchro___: "Sincronizar...",
  forcer_la_synchro: "Forçar sincronização",
  non_synchronis_: "Não sincronizado",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "Conecte seu calendário do Airbnb para evitar reservas duplicadas!",
  bloquer_des_dates: "Bloquear datas",
  s_lection: "Seleção",
  jours: "dias",
  raison__optionnel__ex__travaux_: "Motivo (opcional, por exemplo: Funciona)",
  annuler: "Cancelar",
  confirmer: "Confirmar",
  synchronisation_airbnb: "Sincronização Airbnb",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Adicione seus links do Airbnb para sincronizar automaticamente suas reservas e evitar duplicatas.",
  lien_de_l_annonce_airbnb: "Link de anúncio do Airbnb",
  airbnb_ical_calendar_link: "Link do calendário iCal do Airbnb",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Disponível em Configurações de Anúncios Exportação de Calendário",
  enregistrer: "Salvar",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    "Clique em 'Localizar' para validar o endereço antes de continuar.",
  vous_devez__tre_connect__pour_publier_: "Você deve estar logado para postar.",
  id_manquant_apr_s_sauvegarde: "ID ausente após backup",
  erreur_upload_photo: "Erro no upload da foto",
  erreur_sauvegarde_metadata_photos: "Erro ao salvar fotos de metadados",
  une_erreur_est_survenue_lors_de_la_sauvegarde: "Ocorreu um erro ao salvar",
  quitter: "Para sair",
  modification: "Editar",
  cr_ation: "Criação",
  _tape: "Estágio",
  sur: "sobre",
  sauvegarde_en_cours___: "Backup em andamento...",
  retour: "Voltar",
  sauvegarde___: "Backup...",
  mettre___jour: "Para atualizar",
  publier_l_annonce: "Publique o anúncio",
  suivant: "Seguindo",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "Tem certeza de que deseja remover este anúncio?",
  impossible_de_supprimer_l_annonce__: "Não foi possível excluir o anúncio:",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Gerencie suas acomodações e sua disponibilidade.",
  ajouter_une_annonce: "Adicione um anúncio",
  vous_n_avez_aucune_annonce: "Você não tem anúncios",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Comece a ganhar renda alugando sua casa. It's quick and easy.",
  cr_er_ma_premi_re_annonce: "Criar meu primeiro anúncio",
  publi_: "Publicado",
  brouillon: "Rascunho",
  __nuit: "/ noite",
  voir_l_annonce: "Veja o anúncio",
  modifier: "Para modificar",
  supprimer: "EXCLUIR",
  quels__quipements_proposez_vous__: "Que equipamentos você oferece?",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Selecione tudo o que está disponível para os viajantes.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "Nenhum diagrama de conversa compatível encontrado.",
  logements_concern_s: "habitação em causa",
  logement_non_pr_cis_: "Alojamento não especificado",
  erreur_lors_de_l_envoi_du_message_: "Erro ao enviar mensagem.",
  rechercher_une_conversation: "Procure uma conversa",
  demandes_re_ues: "Solicitações recebidas",
  mes_demandes: "Meus pedidos",
  aucune_demande_re_ue_: "Nenhuma solicitação recebida.",
  aucune_demande_envoy_e_: "Nenhuma solicitação enviada.",
  photo_de_profil: "Foto do perfil",
  localisation_non_pr_cis_e: "Local não especificado",
  listing_: "Listagem:",
  en_ligne: "On-line",
  vous: "VOCÊ",
  _crivez_votre_message___: "Escreva sua mensagem...",
  s_lectionnez_une_conversation: "Selecione uma conversa",
  pour_commencer___changer: "para começar a negociar",
  logement_propos_: "Alojamento proposto",
  description_non_pr_cis_e: "Descrição não especificada",
  ch_: "cap.",
  voy_: "ver.",
  nuit: "noite",
  prix_non_pr_cis_: "Preço não especificado",
  voir: "Ver",
  aucune_annonce_li_e___cette_conversation_:
    "Nenhum anúncio relacionado a esta conversa.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Selecione uma conversa para ver os detalhes.",
  bonjour: "Bom dia",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Veja o que está acontecendo em sua conta hoje.",
  annonces_en_ligne: "Anúncios on-line",
  nouveaux_messages: "Novas postagens",
  prochains__changes: "Próximas trocas",
  matching_section__o__je_veux_aller: "Seção correspondente: Onde eu quero ir",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Adicione até 10 cidades com raio em km e datas de partida para receber propostas mais direcionadas.",
  configurer_mes_pr_f_rences: "Configurar minhas preferências",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "Pronto para receber seus primeiros viajantes?",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Complete seu perfil e publique seu primeiro anúncio para começar a trocar sua acomodação com a comunidade TravelIntercâmbio.",
  cr_er_mon_annonce: "Criar meu anúncio",
  compl_ter_mon_profil: "Completar meu perfil",
  impossible_de_charger_vos_preferences_:
    "Não foi possível carregar suas preferências.",
  preferences_enregistrees_: "Preferências salvas.",
  impossible_d_enregistrer_vos_preferences_:
    "Não foi possível salvar suas preferências.",
  impossible_de_supprimer_votre_profil_: "Não foi possível excluir seu perfil.",
  chargement_des_preferences___: "Carregando preferências...",
  unites_de_distance: "Unidades de distância",
  kilom_tres__km_: "Quilômetros (km)",
  format_europeen_par_defaut: "Formato europeu padrão",
  miles__mi_: "Milhas (mi)",
  format_anglo_saxon: "Formato anglo-saxão",
  visibilite_du_profil: "Visibilidade do perfil",
  mettre_mon_profil_en_pause: "Pausar meu perfil",
  me_masquer_dans_les_resultats_de_recherche:
    "Oculte-me dos resultados da pesquisa",
  zone_sensible: "Área sensível",
  suppression___: "Eliminação...",
  supprimer_mon_profil: "Excluir meu perfil",
  pensez_a_enregistrer_vos_modifications_:
    "Lembre-se de salvar suas alterações.",
  enregistrement___: "Registro...",
  enregistrer_les_preferences: "Salvar preferências",
  impossible_de_charger_votre_profil_: "Não foi possível carregar seu perfil.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Perfil parcialmente salvo. O banco de dados deve ser atualizado (migração SQL).",
  profil_mis___jour_avec_succ_s_: "Perfil atualizado com sucesso.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Perfil não salvo: o banco de dados precisa ser migrado (colunas ausentes).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Perfil não salvo: muitas colunas faltando. Inicie a migração SQL.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Seu banco de dados não está atualizado. Execute a migração SQL e tente novamente.",
  erreur_lors_de_la_mise___jour_: "Erro durante a atualização.",
  photo_de_profil_mise___jour_: "Foto de perfil atualizada.",
  erreur_upload_photo_: "Erro no upload da foto.",
  photo_de_couverture_mise___jour_: "Foto de capa atualizada.",
  erreur_upload_couverture_: "Erro no upload da capa.",
  document_envoy__pour_v_rification_: "Documento enviado para verificação.",
  erreur_lors_de_l_envoi_du_document_: "Erro ao enviar documento.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "Não é possível carregar seu perfil neste momento.",
  mon_profil_h_te: "Meu perfil de anfitrião",
  identit___r_seaux_et_infos_de_matching:
    "Identidade, redes e informações correspondentes",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "Quanto mais completo for o seu perfil, mais hosts compatíveis o mecanismo poderá sugerir.",
  compl_tude_du_profil: "Completude do perfil",
  couverture: "Cobertor",
  photo_principale: "Foto principal",
  h_te_traveltrok: "Anfitrião VIAGEM DE BURRO",
  localisation_non_renseign_e: "Localização não fornecida",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Adicione uma foto grande para apresentar melhor o seu mundo anfitrião.",
  destinations_cibl_es: "Destinos direcionados",
  dates_pr_vues: "Datas planejadas",
  configurer___o__je_veux_aller__: "Configurar “Onde eu quero ir”",
  statut_identit_: "Status de identidade",
  v_rifi_: "Verificado",
  en_cours: "Em andamento",
  non_v_rifi_: "Não verificado",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Adicione ID para construir a confiança da comunidade.",
  envoyer_document: "Enviar documento",
  identit__et_contact: "Identidade e contato",
  pr_nom: "Primeiro nome",
  nom: "Nome",
  pseudo_public: "Apelido público",
  email: "E-mail",
  t_l_phone: "Telefone",
  r_seaux_et_liens: "Redes e links",
  site_web: "Site",
  localisation_et_mode_de_voyage: "Localização e modo de viagem",
  pays_de_r_sidence: "País de Residência",
  s_lectionnez_un_pays: "Selecione um país",
  ville_de_r_sidence: "Cidade de residência",
  amiens: "Amiens",
  combien_de_personnes_voyagent__: "Quantas pessoas estão viajando?",
  voyagez_vous_avec_des_animaux__: "Você viaja com animais?",
  oui: "Sim",
  non: "Não",
  voyagez_vous_avec_des_b_b_s__: "Você está viajando com bebês?",
  bio_h_te: "Biografia do anfitrião",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Apresente seu estilo de hospitalidade e sua acomodação.",
  pr_sentation_de_la_famille: "Apresentação da família",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Quem viaja, hábitos, ritmo, tipo de estadia procurada...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Preencha também “Onde eu quero ir” para ativar uma correspondência mais precisa.",
  enregistrer_le_profil: "Salvar perfil",
  horizon_contrat: "Horizonte do contrato",
  "24_mois_apres_le_1er_sejour": "24 meses após a primeira estadia",
  nuits_que_je_dois: "Noites que devo",
  nuits_qu_on_me_doit: "Noites que devo",
  echanges_ouverts: "Trocas abertas",
  echanges_proches_echeance: "Negociações perto do vencimento",
  alerte_solde_des_echanges: "Alerta de saldo cambial",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "Nenhum perfil de risco detectado no momento.",
  contrats_en_cours: "Contratos atuais",
  personne: "Pessoa",
  logement: "Alojamento",
  contrat: "CONTRATO",
  dates: "Datas",
  echange_effectue: "Troca feita",
  solde_nuits: "Noites de liquidação",
  temps_restant: "Tempo restante",
  "1er_sejour_": "1ª estadia:",
  echeance_: "Data de vencimento:",
  ils_sont_venus__fait: "Eles vieram: pronto",
  ils_sont_venus__en_attente: "Eles vieram: esperando",
  je_suis_alle__fait: "eu fui: pronto",
  je_suis_alle__en_attente: "Eu fui: esperando",
  je_dois: "eu tenho que",
  nuits: "noites",
  on_me_doit: "estou devendo",
  carte_des_p_rim_tres_de_recherche: "Mapa das áreas de pesquisa",
  villes_localis_es: "cidades localizadas",
  mise___jour_de_la_carte___: "Atualizando o mapa...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "Você deve estar logado para gerenciar suas preferências.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "Não é possível carregar suas preferências correspondentes neste momento.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Adicione pelo menos uma cidade alvo para ativar a correspondência.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "Um período tem uma data de término anterior à data de início.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Selecione pelo menos um país se você ativar o filtro de contatos por país.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Preferências salvas. Os países de destino são mantidos localmente até que a migração SQL seja aplicada.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Preferências correspondentes salvas com sucesso.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Preferências não salvas: banco de dados não migrado. Inicie a migração SQL.",
  erreur_lors_de_l_enregistrement_: "Erro ao salvar.",
  matching_intelligent: "Correspondência inteligente",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Indique as cidades-alvo e os períodos de partida: a DONKEY TRAVEL poderá oferecer os anfitriões mais compatíveis.",
  retour_au_profil: "Voltar ao perfil",
  villes_et_rayon_de_recherche: "Cidades e raio de pesquisa",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Até 10 cidades (ex.: Amiens 2 km, Paris 5 km, Lille 20 km).",
  villes_actives: "cidades ativas",
  ville: "Cidade",
  choisir_un_pays: "Escolha um país",
  saisissez_une_ville: "Insira uma cidade",
  choisissez_le_pays_d_abord: "Escolha o país primeiro",
  rayon: "Raio",
  supprimer_cette_ville: "Excluir esta cidade",
  ajouter_une_ville: "Adicionar uma cidade",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "Estas cidades serão utilizadas para oferecer intercâmbios direcionados.",
  enregistrer_mes_pr_f_rences: "Salvar minhas preferências",
  pays_d_europe___visiter: "Países europeus para visitar",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Verifique os países que lhe interessam. Você pode então limitar os contatos a esses países.",
  pays_s_lectionn_s: "países selecionados",
  tout_cocher: "Verifique tudo",
  tout_d_cocher: "Desmarque tudo",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Ser contatado apenas por membros desses países",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "Este filtro será usado na sua correspondência automática.",
  union_europ_enne: "União Europeia",
  hors_union_europ_enne: "Fora da União Europeia",
  agenda_des_d_parts_souhait_s: "Cronograma de saídas desejadas",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Adicione os períodos em que deseja sair para começar a combinar em slots comuns.",
  p_riode_s__active_s_: "período(s) ativo(s)",
  aucune_p_riode_ajout_e_pour_le_moment_: "Nenhum período adicionado ainda.",
  p_riode: "Período",
  supprimer_cette_p_riode: "Excluir este período",
  d_part: "Partida",
  commentaire__optionnel_: "Comentário (opcional)",
  ajouter_une_p_riode: "Adicionar um período",
  r_sum__matching: "Correspondência de resumo",
  villes_cibles: "Cidades alvo",
  rayon_moyen: "Raio médio",
  p_riodes_planifi_es: "Períodos planejados",
  pays_cibl_s: "Países segmentados",
  contacts_limit_s_aux_pays_coch_s: "Contatos limitados aos países verificados",
  contacts_ouverts___tous_les_pays: "Contatos abertos a todos os países",
  agenda_aper_u: "Visão geral da agenda",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Adicione um período para exibir seu calendário de partidas.",
  sans_commentaire: "Sem comentários",
  logement_traveltrok: "Alojamento VIAGEM DE BURRO",
  localisation_a_preciser: "Local a especificar",
  logements_trouves: "acomodação encontrada",
  plus_recents: "Mais recente",
  capacite_max: "Capacidade máxima",
  h_tes: "Anfitriões",
  villes: "Cidades",
  logements_disponibles: "Acomodações disponíveis",
  pays_disponibles: "Países disponíveis",
  marie_accepte__: "Maria aceita!",
  nuits_a_reims_contre: "noites em Reims contra",
  nuits_a_paris: "noites em Paris",
  l_histoire_de_marie_jean: "A história de Marie e Jean",
  "1__marie_consulte_l_agenda_de_jean": "1. Marie consulta o diário de Jean",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "Ela vê que Jean tem encontros livres em 2 semanas. Perfeito para ela! Jean confirma que pode divulgar essas datas.",
  h_tes_actifs: "Hosts ativos",
  pays_couverts: "Países abrangidos",
  echanges_realises: "Trocas feitas",
  "100__match": "100% de correspondência",
  echanges_longue_distance: "Trocas de longa distância",
  matching_algorithmique_intelligent: "Correspondência algorítmica inteligente",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "O nosso algoritmo cruza a informação do seu perfil e das suas pesquisas para lhe oferecer todos os anúncios de habitação que correspondam exatamente ao seu pedido.",
  matching_precis: "Correspondência precisa",
  analyse_intelligente_de_vos_crit_res:
    "Análise inteligente dos seus critérios",
  gain_de_temps_dans_vos_recherches: "Economize tempo em sua pesquisa",
  propositions_ultra_pertinentes: "Propostas ultra-relevantes",
  habitants: "residentes",
  destinations_europeennes: "Destinos Europeus",
  decouvrez_les_merveilles_du_continent: "Descubra as maravilhas do continente",
  pays_actifs_sur_traveltrok: "Países ativos na DONKEY TRAVEL",
  selectionner_un_pays: "Selecione um país",
  union_europeenne: "União Europeia",
  hors_union_europeenne: "Fora da União Europeia",
  fiche_detaillee: "Folha detalhada",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Selecione um país na lista ou no mapa para descobrir o clima, a população e os locais emblemáticos.",
  logements_actifs: "habitação ativa",
  climat: "Clima",
  information_touristique: "Informação Turística",
  lieux_emblematiques: "Lugares icônicos",
  gastronomie: "Gastronomia",
  dom_tom___outre_mer: "DOM-TOM / Exterior",
  villes_principales: "Principais cidades",
  charte_officielle: "Carta oficial",
  confiance_mutuelle: "Confiança mútua",
  r_gles_claires: "Regras claras",
  sanctions_applicables: "Sanções aplicáveis",
  illustration_3d_des_engagements: "Ilustração 3D de compromissos",
  concept_3d_informations: "Imagem 3D de detalhes",
  principe_1: "Princípio 1",
  v_racit__des_informations: "Veracidade das informações",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "Perfil, acomodação, fotos e preços devem ser precisos.",
  concept_3d_respect_du_lieu: "Imagem 3D de respeito pelo lugar",
  principe_2: "Princípio 2",
  respect_du_lieu: "Respeito pelo lugar",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "Sem festas e sem incômodo para o bairro.",
  concept_3d_fiabilit__contractuelle: "Conceito de contrato em 3D",
  principe_3: "Princípio 3",
  fiabilit__contractuelle: "Confiabilidade contratual",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Datas bloqueadas = compromisso firme, a menos que haja um motivo válido.",
  engagements_c_t__voyageur: "Compromissos do lado do passageiro",
  engagements_c_t__h_te: "Compromissos do lado do anfitrião",
  annulations_et_reports: "Cancelamentos e adiamentos",
  r_gle_op_rationnelle: "Regra operacional",
  check_list_d_part_voyageur: "Lista de verificação de partida",
  cuisine_et_vaisselle_propres: "Cozinha e pratos limpos",
  sols_et_surfaces_rendus_propres: "Pisos e superfícies limpos",
  linge_utilis__d_pos__selon_consigne:
    "Roupa usada depositada de acordo com as instruções",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "Sem convites não autorizados",
  _tat_final_du_logement_confirm__avec_photos:
    "Condição final da habitação confirmada",
  sanctions_en_cas_de_manquement: "Sanções em caso de descumprimento",
  ce_que_permet_traveltrok: "O que a DONKEY TRAVEL permite",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "Você pode listar quantas acomodações desejar.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Troca sem limite de recorrência durante o ano.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "Um contrato formal vincula oficialmente os anfitriões e garante o sucesso.",
  r_f_rences_de_bonnes_pratiques: "Referências de melhores práticas",
  un_club_s_rieux__une_communaut__durable:
    "Um clube sério cria uma comunidade duradoura",
  retour_au_guide_complet: "Voltar ao guia completo",
  carte_des_logements_traveltrok: "Mapa de hospedagem DONKEY TRAVEL",
  points_logements: "Pontos de acomodação",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "Nenhum dado geolocalizado no momento.",
  envie_d_entrer_dans_la_carte__: "Quer entrar no mapa?",
  chargement_des_logements___: "Carregando habitação...",
  la_date_d_arriv_e_est_requise: "A data de chegada é obrigatória",
  la_date_ne_peut_pas__tre_dans_le_pass_: "A data não pode estar no passado",
  la_date_de_d_part_est_requise: "A data de partida é obrigatória",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "A data de partida deve ser posterior à chegada",
  le_message_doit_contenir_au_moins_10_caract_res:
    "A mensagem deve conter pelo menos 10 caracteres",
  veuillez_corriger_les_erreurs_ci_dessus: "Corrija os erros acima",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "Ocorreu um erro. Por favor, tente novamente.",
  paris__france: "Paris, França",
  mode_h_te: "Modo anfitrião",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "Alugo algumas semanas por ano. O modelo de 1EUR/noite é super simples de explicar aos viajantes.",
  "37_nuits": "37 noites",
  lyon__france: "Lyon, França",
  mode_voyageur: "Moda viajante",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "A reserva é tranquila e, acima de tudo, as taxas são legíveis. Comparo facilmente o custo final antes de confirmar.",
  "22_nuits": "22 noites",
  bordeaux__france: "Bordéus, França",
  "54_nuits": "54 noites",
  marseille__france: "Marselha, França",
  pro_multi_logements: "Multi-habitação profissional",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "Com múltiplas propriedades, a versão Pro economiza muito tempo no agendamento e gerenciamento de solicitações.",
  "9_logements": "9 acomodações",
  retours_utilisateurs: "Feedback do usuário",
  des_retours_terrain_concrets: "Feedback de campo concreto",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Viajantes e anfitriões que desejam um aluguel mais claro e acessível.",
  activit_: "atividade",
  _conomie_estim_e: "economia estimada",
  profils_et_logements_v_rifi_s: "Perfis verificados e acomodações",
  exp_rience_location_simplifi_e: "Experiência de aluguel simplificada",
  co_ts_transparents___la_nuit: "Custos transparentes à noite",
  marquer_des_dates: "Marcar datas",
  je_peux_accueillir: "Eu posso acomodar",
  je_veux_partir: "eu quero ir embora",
  partir_et_accueillir: "Partida e Bem-vindo",
  accueillir: "Para dar as boas-vindas",
  partir: "Deixar",
  bloquer_les_dates: "Bloquear datas",
  toujours_partir_et_accueillir: "Sempre saia e seja bem-vindo",
  rendre_ce_logement_visible: "Torne esta acomodação visível",
  rendre_ce_logement_invisible: "Torne esta acomodação invisível",
  confirmation_visibilite_logement:
    "Tem certeza de que deseja alterar a visibilidade DESTA listagem para outros membros?",
  confirmer_activer_toujours_partir_accueillir:
    "Ao ativar este modo, novas disponibilidades de 'Sair e Bem-vindo' serão adicionadas para cobrir sempre os próximos 2 anos a partir de hoje. Outras disponibilidades manuais serão substituídas.\n\nTem certeza de que deseja continuar?",
  confirmer_desactiver_toujours_partir_accueillir:
    "Tem certeza de que deseja desativar o modo 'Sempre sair e cumprimentar'?",
  details_de_l_adresse__optionnel_: "Detalhes do endereço (opcional)",
  rue_et_numero: "Rua e número",
  ex__12_rue_de_la_paix: "Exemplo: Rua de la Paix, 12",
  appartement_suite: "Apartamento, suíte, etc.",
  ex__apt_4b: "Ex: Apto 4B",
  etage: "Chão",
  ex__3eme_sans_ascenseur: "Ex: 3º",
  code_d_acces: "Código de acesso (porta/edifício)",
  ex__a1234: "Exemplo: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "Esta informação detalhada só será comunicada aos membros que tenham uma troca confirmada consigo.",
  lits_doubles: "Camas de casal",
  lits_simples: "Camas de solteiro",
  canapes_lits: "Sofás-cama",
  lits_bebes: "Camas de bebê",
  amenity_cat_essentials: "O essencial",
  amenity_cat_kitchen: "Culinária e refeições",
  amenity_cat_bathroom: "Banheiro",
  amenity_cat_bedroom_laundry: "Quarto e roupa de cama",
  amenity_cat_entertainment: "Entretenimento",
  amenity_cat_family: "Família",
  amenity_cat_exterior: "Fora",
  amenity_cat_features: "Características",
  amenity_cat_location: "Localização",
  amenity_cat_safety: "Segurança",
  amenity_wifi: "Wi-fi",
  amenity_workspace: "Espaço de trabalho dedicado",
  amenity_ac: "Ar condicionado",
  amenity_heating: "Aquecimento",
  amenity_kitchen: "Cozinha",
  amenity_refrigerator: "Geladeira",
  amenity_microwave: "Microondas",
  amenity_oven: "Forno",
  amenity_dishwasher: "Máquina de lavar louça",
  amenity_coffee_maker: "Máquina de café",
  amenity_kettle: "Chaleira",
  amenity_bathtub: "Banheira",
  amenity_hair_dryer: "secador de cabelo",
  amenity_shampoo: "Shampoo e gel de banho",
  amenity_hot_water: "água quente",
  amenity_washing_machine: "Máquina de lavar",
  amenity_dryer: "Secador",
  amenity_iron: "Ferro",
  amenity_hangers: "Cabides",
  amenity_bed_linens: "Roupa de cama fornecida",
  amenity_tv: "Televisão",
  amenity_game_console: "Consola de jogos",
  amenity_books_toys: "Livros e brinquedos",
  amenity_sound_system: "Sistema de áudio",
  amenity_high_chair: "Cadeira alta",
  amenity_baby_bath: "Banho de bebê",
  amenity_travel_cot: "Berço de viagem",
  amenity_changing_table: "Trocador de mesa",
  amenity_patio: "Varanda ou terraço",
  amenity_garden: "Jardim privado",
  amenity_bbq: "Churrasco",
  amenity_outdoor_furniture: "Móveis de exterior",
  amenity_pool: "Piscina",
  amenity_hottub: "Jacuzzi",
  amenity_gym: "Academia",
  amenity_fireplace: "Chaminé",
  amenity_breakfast: "Café da manhã incluído",
  amenity_parking: "Estacionamento gratuito",
  amenity_ev_charger: "Estação de carregamento de veículos elétricos",
  amenity_beachfront: "Acesso à praia",
  amenity_ski_in_out: "Acesso às pistas de esqui",
  amenity_lake_access: "Acesso ao lago",
  amenity_smoke_detector: "Detector de fumaça",
  amenity_first_aid: "Kit de primeiros socorros",
  amenity_fire_extinguisher: "Extintor",
  amenity_sauna: "Sauna",
  amenity_massage_chair: "Cadeira de massagem",
  amenity_shower: "Banho",
  amenity_home_cinema: "Cinema em Casa",
  amenity_ping_pong: "Mesa de pingue-pongue",
  amenity_forest_access: "Acesso à floresta",
  amenity_hiking_access: "Acesso a caminhadas",
  compl_t_: "concluído",
  l_adresse_doit_tre_localis_e_sur_la_carte:
    "O endereço deve estar localizado no mapa",
  au_moins_3_photos_requises: "São necessárias pelo menos 3 fotos",
  le_titre_doit_faire_au_moins_10_caract_res:
    "O título deve ter pelo menos 10 caracteres",
  la_description_doit_faire_au_moins_50_caract:
    "A descrição deve ter pelo menos 50 caracteres",
  s_lectionnez_au_moins_3_quipements: "Selecione pelo menos 3 equipamentos",
  encore_quelques_d_tails_avant_de_publier:
    "Mais alguns detalhes antes de publicar",
  votre_annonce_est_compl_t_e_x:
    "Seu anúncio foi concluído em {{score}}%. Por favor preencha os elementos que faltam para poder publicá-lo:",
  compl_ter: "Completo",
  voici_comment_les_voyageurs_verront_votre_:
    "É assim que os viajantes verão o seu anúncio.",
  photo: "Foto",
  afficher_toutes_les_photos: "Mostrar todas as fotos",
  h_t_par_vous: "• Anfitrião: você",
  description: "Sobre este alojamento",
  votre_description_appara_tra_ici: "Sua descrição aparecerá aqui...",
  afficher_les_n__quipements_x: "Mostre a eles{{count}}equipamento",
  ajouter_une_date: "Adicione uma data",
  aucun_montant_ne_vous_sera_d_bit_:
    "Nenhum valor será cobrado de você neste momento",
  demander: "Perguntar",
  enregistrer_et_quitter: "Salvar e sair",
  enregistrer_pour_plus_tard: "Salvar para mais tarde",
  conseils_pour_des_photos_r_ussies: "Dicas para fotos de sucesso",
  privil_giez_le_format_paysage__1:
    "Escolha o formato paisagem (16:9) para melhor exibição.",
  prenez_vos_photos_de_jour__avec_:
    "Tire suas fotos durante o dia, com boa luz natural.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Guarde e limpe as peças antes de fotografá-las.",
  mettez_en_avant_les_atouts_de_vo:
    "Destaque os trunfos do seu alojamento (vista, terraço, bela sala, etc.).",
  donnez_un_titre___votre_annonce: "Dê um título ao seu anúncio",
  un_titre_court_et_accrocheur_attirera_pl:
    "Um título curto e cativante atrairá mais viajantes.",
  souhaite_visiter: "Gostaria de visitar",
  vous_propose_en_change: "Oferece a você em troca",
  autres_logements: "outro alojamento",
  voir_le_logement: "Veja o alojamento",
  votre_demande_titre: "Seu pedido",
  votre_demande_soustitre:
    "Resumo de seus desejos de viagem e companheiros para seus futuros intercâmbios.",
  compagnons_de_voyage: "Companheiros de viagem",
  voyage_avec_bebe: "Bebês)",
  voyage_avec_animaux: "Animais de estimação",
  disponibilites_souhaitees: "Disponibilidade desejada",
  destinations_cibles: "Destinos alvo",
  aucune_date_precisee: "Nenhuma data de viagem foi especificada.",
  aucune_destination_precisee: "Nenhum destino de destino foi especificado.",
  votre_demande_menu: "Seu pedido",
  modifier_mon_profil: "Editar meu perfil",
  rayon_de: "Raio de{{km}}quilômetros",
  dates_flexibles_option: "Datas flexíveis",
  animaux_de_compagnie_details: "{{count}}animal/animais",
  changer_d_annonce: "Alterar anúncio",
  profil_du_voyageur: "Perfil do viajante",
  chambres_requises: "Salas obrigatórias",
  animaux: "animal(es)",
  duree_du_sejour_souhaitee: "Duração desejada da estadia",
  combien_de_chambres_avez_vous_besoin__: "Quantos quartos você precisa?",
  combien_de_b_b_s__: "Quantos bebês?",
  combien__: "Quanto ?",
  vos_animaux: "Seus animais",
  chien_s_: "Cachorro(s)",
  plus_de_30_nuits: "Mais de 30 noites",
  "community.hero.badge": "Nossa comunidade",
  "community.hero.title": "Junte-se à rede de hosts mais autêntica",
  "community.hero.subtitle":
    "Compartilhe mais do que apenas sua casa. Descubra histórias, conheça anfitriões apaixonados e viaje com confiança.",
  "community.stats.members": "Membros Ativos",
  "community.stats.countries": "Países Representados",
  "community.stats.exchanges": "Trocas feitas",
  "community.values.title": "O que nos une",
  "community.values.trust.title": "Confiança Absoluta",
  "community.values.trust.desc":
    "Cada membro é um anfitrião verificado, garantindo o respeito mútuo pelas instalações.",
  "community.values.sharing.title": "Compartilhamento e reuniões",
  "community.values.sharing.desc":
    "A oportunidade de criar ligações com habitantes locais de toda a Europa.",
  "community.values.savings.title": "Economias reais",
  "community.values.savings.desc":
    "Viaje com mais frequência e mais longe, preservando seu orçamento.",
  "community.testimonials.title": "Histórias de membros",
  "community.cta.title": "Pronto para fazer parte da aventura?",
  "community.cta.button": "Torne-se um membro hoje",
  "blog.hero.badge": "Nosso blog",
  "blog.hero.title": "Inspiração e dicas",
  "blog.hero.subtitle":
    "Conheça histórias de viagens, dicas para preparar sua hospedagem e novidades do clube.",
  "blog.categories.all": "Todos os artigos",
  "blog.categories.tips": "Dicas para anfitriões",
  "blog.categories.inspiration": "Inspiração de viagem",
  "blog.categories.news": "Notícias",
  "blog.empty": "Nenhum artigo no momento. Volte logo!",
  "help.hero.badge": "Central de Ajuda",
  "help.hero.title": "Como podemos ajudá-lo?",
  "help.hero.subtitle":
    "Encontre respostas rápidas ou entre em contato com nossa equipe de suporte.",
  "help.search.placeholder": "Procure uma resposta...",
  "help.categories.account.title": "Conta e perfil",
  "help.categories.account.desc":
    "Gerencie suas informações, senhas e preferências.",
  "help.categories.exchanges.title": "Trocas e Reservas",
  "help.categories.exchanges.desc":
    "Como oferecer, aceitar ou cancelar uma troca.",
  "help.categories.trust.title": "Confiança e Segurança",
  "help.categories.trust.desc":
    "Contratos, verificação e proteção de habitação.",
  "help.faq.title": "Perguntas frequentes",
  "help.contact.cta": "Não encontrou sua resposta?",
  "help.contact.button": "Contate-nos",
  "careers.hero.badge": "Junte-se à equipe",
  "careers.hero.title": "Vamos construir o futuro das viagens",
  "careers.hero.subtitle":
    "Procuramos pessoas apaixonadas para redefinir a forma como os hóspedes viajam na Europa.",
  "careers.values.title": "Nossos valores",
  "careers.values.trust.title": "Humano e Confiança",
  "careers.values.remote.title": "Teletrabalho flexível",
  "careers.values.impact.title": "Impacto Real",
  "careers.openings.title": "Posições abertas",
  "careers.openings.empty":
    "Nenhuma posição aberta no momento. Não hesite em enviar uma candidatura espontânea!",
  "careers.apply.title": "Candidatura Espontânea",
  "careers.apply.desc":
    "Envie o seu CV e diga-nos como pode ajudar a Donkey Travel.",
  "careers.apply.button": "Enviar minha inscrição",
  "contact.hero.badge": "Contato",
  "contact.hero.title": "Estamos aqui para você",
  "contact.hero.subtitle":
    "Uma dúvida, sugestão ou problema? Nossa equipe está pronta para ouvir você.",
  "contact.form.name": "Seu nome",
  "contact.form.email": "Seu e-mail",
  "contact.form.subject": "Assunto da sua mensagem",
  "contact.form.message": "Sua mensagem...",
  "contact.form.send": "Enviar mensagem",
  "contact.info.title": "Informações úteis",
  "contact.info.email": "contact@donkey.travel",
  "contact.info.address": "Vale Haute-Somme, Picardia, França",
  "contact.info.hours": "Seg - Sex: 9h00 - 18h00",
  activez_votre_abonnement: "Ative sua assinatura",
  finalisez_votre_inscription: "Finalize seu cadastro",
  _changes_illimit_s_en_europe: "Trocas ilimitadas na Europa",
  validit___1_an: "Validade: 1 ano",
  paiement_100__s_curis__par_paypal: "Pagamento 100% seguro por PayPal",
  me_d_connecter_et_revenir_plus_tard: "Saia e volte mais tarde",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Erro ao validar o pagamento em nossos servidores.",
  le_paiement_n_a_pas_pu__tre_valid_: "O pagamento não pôde ser validado.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "Ocorreu um erro desconhecido durante o pagamento.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "Não foi possível inicializar o PayPal. Verifique sua conexão.",
  donn_es_personnelles: "Dados pessoais",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Junte-se à nossa comunidade e reserve acomodação em {{city}} com taxas fixas claras e seguro incluído.",
  bienvenue: "Bem-vindo",
  code_promo_applique_avec_succes: "Código promocional aplicado com sucesso!",
  cible: "Alvo",
  propose: "Propor",
  "1_sens": "1 sentido",
  "2_sens": "2 sentidos",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "Eles querem visitar sua região.<br />Cabe a você descobrir onde eles moram!",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "Eles estão procurando por você E<br />eles moram onde você quer ir!",
  comment_ca_marche: "Como funciona?",
  comprendre_les_differents_types_de_matching:
    "Compreender os diferentes tipos de correspondência",
  match_reciproque: "Correspondência recíproca",
  details_de_la_demande: "Solicitar detalhes",
  souhaite_venir_dans_votre_secteur: "Gostaria de ir até sua região:",
  peut_vous_accueillir: "Pode acomodar você:",
  souhaite_visiter_dans_un_rayon:
    "Gostaria de visitar <strong>{{city}}</strong> num raio de <strong>{{radius}} km</strong>, o seu alojamento corresponde à pesquisa.",
  souhaite_visiter_ville:
    "Gostaria de visitar <strong>{{city}}</strong>, sua acomodação corresponde à pesquisa deles.",
  a_besoin_de_chambres: "Precisa de {{count}} quartos.",
  comparateur_de_valeur: "Comparador de valor",
  ecart: "brecha",
  code_promo_invalide: "Código promocional inválido",
  erreur_verification_code: "Erroro ao verificar o código",
  vous_avez_un_code_promo: "Você tem um código promocional?",
  entrez_votre_code: "INSIRA SEU CÓDIGO",
  appliquer: "Aplicar",
  importation_r_ussie_:
    "Importação bem sucedida! Suas informações foram pré-preenchidas.",
  erreur_lors_de_l_importation: "Erro durante a importação:",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Descreva o que torna sua casa única...",
  mettez_en_avant_les_points_forts___votre:
    "Destaque os pontos fortes do seu alojamento",
  lien_annonce_airbnb_1: "Link para o seu anúncio do Airbnb",
  importation___: "Importar...",
  importer_l_annonce: "Importar anúncio",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Insira o link do seu anúncio. Você pode importar os detalhes automaticamente para economizar tempo.",
  lien_calendrier_airbnb: "Link do calendário (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "Usaremos este link para sincronizar sua disponibilidade.",
  entrer_en_contact: "Entre em contato",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Aviso: alto risco de dependência de viagens gratuitas!",
};
